import { Paso } from './Paso';

export class PasoPerifericos extends Paso {
  constructor() {
    super(
      false,
      'Periféricos',
      'Mouses, Teclados, MousePad, Auriculares, Coolers, y mas',
      10,
      'devices.png',
      'devices.png',
      true,
      [
        {
          nombre: 'Mouses',
          icono: 'mouse',
          filtro: {
            campo: 'id_subcategoria',
            valor: [2],
          },
        },
        {
          nombre: 'Mouse Pads',
          icono: 'call_to_action',
          filtro: {
            campo: 'id_subcategoria',
            valor: [38],
          },
        },
        {
          nombre: 'Auriculares',
          icono: 'headset_mic',
          filtro: {
            campo: 'id_subcategoria',
            valor: [8],
          },
        },
        {
          nombre: 'Teclados',
          icono: 'keyboard',
          filtro: {
            campo: 'id_subcategoria',
            valor: [39],
          },
        },
        {
          nombre: 'Coolerfan',
          svg: 'coolerfan',
          filtro: {
            campo: 'id_subcategoria',
            valor: [35],
          },
        },
        {
          nombre: 'Todos',
          icono: '',
          filtro: {
            campo: 'id_subcategoria',
            valor: [],
          },
        },
      ],
      'subcate',
    );
    super.ordenarFiltros();
  }
}
